"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _InfoLabel = _interopRequireDefault(require("../../components/InfoLabel"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _useEnsureDeploymentIds = _interopRequireDefault(require("../../hooks/useEnsureDeploymentIds"));
var _flag = _interopRequireDefault(require("cccisd-icons/flag7"));
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _StatusTable = _interopRequireDefault(require("./StatusTable"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var Status = function Status(props) {
  var assignmentId = props.assignmentId,
    assignmentIdWhitelist = props.assignmentIdWhitelist,
    customSwitchProject = props.customSwitchProject,
    deploymentIdWhitelist = props.deploymentIdWhitelist,
    deploymentIds = props.deploymentIds,
    hideDeploymentDropdown = props.hideDeploymentDropdown,
    hideProjectDropdown = props.hideProjectDropdown,
    hideQuestDropdown = props.hideQuestDropdown,
    hideSystemId = props.hideSystemId,
    isExported = props.isExported,
    labelForDeployment = props.labelForDeployment,
    _props$labelForLesson = props.labelForLesson,
    labelForLesson = _props$labelForLesson === void 0 ? 'Lesson' : _props$labelForLesson,
    labelForProject = props.labelForProject,
    labelForProjectPlural = props.labelForProjectPlural,
    labelForQuest = props.labelForQuest,
    labelForShowByAssignment = props.labelForShowByAssignment,
    labelForShowByModule = props.labelForShowByModule,
    labelForShowBySurvey = props.labelForShowBySurvey,
    labelForSurvey = props.labelForSurvey,
    pawnIdWhitelist = props.pawnIdWhitelist,
    project = props.project,
    projectAssignments = props.projectAssignments,
    projectIdWhitelist = props.projectIdWhitelist,
    showByWhitelist = props.showByWhitelist,
    surveyHandleWhitelist = props.surveyHandleWhitelist,
    renderCertificate = props.renderCertificate,
    setColumnDefinitions = props.setColumnDefinitions,
    showOnlyFlags = props.showOnlyFlags,
    overrideDeploymentIds = props.overrideDeploymentIds,
    adjustColumns = props.adjustColumns,
    customQuery = props.customQuery,
    customQueryVariables = props.customQueryVariables,
    hideResolveAction = props.hideResolveAction,
    roleHandles = props.roleHandles;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasModules = _useState4[0],
    setHasModules = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    modules = _useState6[0],
    setModules = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    flags = _useState8[0],
    setFlags = _useState8[1];
  var _useState9 = (0, _react.useState)(labelForSurvey || 'Survey'),
    _useState0 = _slicedToArray(_useState9, 2),
    surveyButtonLabel = _useState0[0],
    setSurveyButtonLabel = _useState0[1];
  var _useState1 = (0, _react.useState)(showByWhitelist.length > 0 ? showByWhitelist[0] : 'assignment'),
    _useState10 = _slicedToArray(_useState1, 2),
    showBy = _useState10[0],
    setShowBy = _useState10[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentAssignment = projectAssignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  var deploymentId = deploymentIds[0];
  (0, _useEnsureDeploymentIds["default"])();

  // ensure current assignment ID is in assignmentIdWhitelist
  (0, _react.useEffect)(function () {
    if (currentAssignment && Array.isArray(assignmentIdWhitelist) && !assignmentIdWhitelist.includes(currentAssignment.assignmentId) && Array.isArray(projectAssignments)) {
      var initialAssignment = projectAssignments.find(function (a) {
        return assignmentIdWhitelist.includes(a.assignmentId);
      });
      if (initialAssignment) {
        dispatch((0, _admin2.setCurrentAssignmentId)(initialAssignment.assignmentId));
      }
    }
  }, [currentAssignment]);
  (0, _react.useEffect)(function () {
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var getFlagList;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            getFlagList = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var response;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _context.n = 1;
                      return _cccisdAxios["default"].get(Boilerplate.route('api.assignment.flag.index') + "?deploymentId=".concat(deploymentId));
                    case 1:
                      response = _context.v;
                      setFlags(response.data.data.filter(function (item) {
                        return item.flagCount > 0;
                      }).map(function (item) {
                        return {
                          id: item.id,
                          name: item.name,
                          total: item.flagCount
                        };
                      }));
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              }));
              return function getFlagList() {
                return _ref2.apply(this, arguments);
              };
            }();
            setLoading(true);
            if (!currentAssignment) {
              _context2.n = 1;
              break;
            }
            _context2.n = 1;
            return getColumns();
          case 1:
            _context2.n = 2;
            return getFlagList();
          case 2:
            setLoading(false);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  }, [currentAssignment, deploymentId]);
  var getColumns = function getColumns() {
    // Determine if assignment has modules
    var navigation = (0, _get2["default"])(currentAssignment, 'settings.navigation', '');
    var navigationSettings = (0, _get2["default"])(currentAssignment, 'settings.navigationSettings', {});
    if (navigation.startsWith('courseWrapper')) {
      navigation = (0, _get2["default"])(currentAssignment, 'settings.navigationSettings.course.navigation', '');
      navigationSettings = (0, _get2["default"])(navigationSettings, 'course.navigationSettings', {});
    }
    var _modules = navigation.startsWith('module') && (0, _get2["default"])(navigationSettings, 'modules', []) || [];
    setHasModules(_modules.length > 0);
    setModules(_modules);
    setSurveyButtonLabel(_modules.length > 0 ? labelForLesson || 'Lesson' : labelForSurvey || 'Survey');
    if (_modules.length <= 0 && showBy === 'module') {
      setShowBy('assignment');
    }
    return null;
  };
  var getButtons = function getButtons() {
    if (showByWhitelist.length <= 1) {
      return;
    }
    if (hasModules) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: !hideDeploymentDropdown || !hideProjectDropdown || !hideQuestDropdown ? _style["default"].showByContainer : _style["default"].showByContainerNoHeader
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        label: "Show by"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, showByWhitelist.includes('assignment') && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setShowBy('assignment');
        },
        className: 'btn ' + (showBy === 'assignment' ? 'disabled btn-primary' : 'btn-secondary')
      }, labelForShowByAssignment || 'Course'), showByWhitelist.includes('module') && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setShowBy('module');
        },
        className: 'btn ' + (showBy === 'module' ? 'disabled btn-primary' : 'btn-secondary')
      }, labelForShowByModule || 'Module'), showByWhitelist.includes('survey') && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setShowBy('survey');
        },
        className: 'btn ' + (showBy === 'survey' ? 'disabled btn-primary' : 'btn-secondary')
      }, labelForShowBySurvey || surveyButtonLabel || 'Survey')));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '1em',
        marginBottom: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Show by"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group"
    }, showByWhitelist.includes('assignment') && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setShowBy('assignment');
      },
      className: 'btn ' + (showBy === 'assignment' ? 'disabled btn-primary' : 'btn-secondary')
    }, labelForQuest || 'Quest'), showByWhitelist.includes('survey') && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setShowBy('survey');
      },
      className: 'btn ' + (showBy === 'survey' ? 'disabled btn-primary' : 'btn-secondary')
    }, surveyButtonLabel)));
  };
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  if (!Fortress.hasAnyAccess(_questPermissionsByArea["default"].status.permissions, project && project.groupId || 0)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], {
      customSwitchProject: customSwitchProject,
      hideProjectDropdown: hideProjectDropdown,
      isExported: isExported,
      labelForProject: labelForProject,
      labelForProjectPlural: labelForProjectPlural,
      limitProjectsByPermissions: _questPermissionsByArea["default"].status.permissions,
      projectIdWhitelist: projectIdWhitelist
    });
  }
  var getContent = function getContent() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      flagId = _ref3.flagId;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !currentAssignment && /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], {
      isExported: isExported
    }), !!currentAssignment && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, deploymentIds.length > 0 && getButtons(), deploymentIds.length > 0 && /*#__PURE__*/_react["default"].createElement(_StatusTable["default"], {
      hideSystemId: hideSystemId,
      modules: modules,
      pawnIdWhitelist: pawnIdWhitelist,
      showBy: showBy,
      surveyHandleWhitelist: surveyHandleWhitelist,
      renderCertificate: renderCertificate,
      setColumnDefinitions: setColumnDefinitions,
      flagId: flagId,
      overrideDeploymentIds: overrideDeploymentIds,
      adjustColumns: adjustColumns,
      customQuery: customQuery,
      customQueryVariables: customQueryVariables,
      hideResolveAction: hideResolveAction,
      roleHandles: roleHandles
    }), !deploymentIds.length && /*#__PURE__*/_react["default"].createElement("h3", {
      className: _style["default"].info
    }, "Please select a ", labelForDeployment || 'Data Collection Wave')));
  };
  var totalFlags = flags.reduce(function (sum, item) {
    return sum + item.total;
  }, 0);
  var tabList = [].concat(_toConsumableArray(showOnlyFlags ? [] : [{
    name: 'progress',
    title: 'Progress',
    content: /*#__PURE__*/_react["default"].createElement("div", {
      key: "progress"
    }, getContent())
  }]), _toConsumableArray(totalFlags > 0 || showOnlyFlags ? [{
    name: 'flags',
    title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_flag["default"], {
      spaceRight: true
    }), "Flags (", totalFlags, ")"),
    content: /*#__PURE__*/_react["default"].createElement("div", {
      key: "keys"
    }, getContent({
      flagId: flags.map(function (flag) {
        return flag.id;
      })
    }))
  }] : []));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (!hideDeploymentDropdown || !hideProjectDropdown || !hideQuestDropdown) && /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    assignmentIdWhitelist: assignmentIdWhitelist,
    customSwitchProject: customSwitchProject,
    deploymentDropdownNotMulti: true,
    deploymentIdWhitelist: deploymentIdWhitelist,
    isExported: isExported,
    labelForDeployment: labelForDeployment,
    labelForProject: labelForProject,
    labelForProjectPlural: labelForProjectPlural,
    labelForQuest: labelForQuest,
    labelForSurvey: labelForSurvey,
    limitProjectsByPermissions: _questPermissionsByArea["default"].status.permissions,
    projectIdWhitelist: projectIdWhitelist,
    showDeploymentDropdown: !hideDeploymentDropdown,
    showProjectDropdown: !hideProjectDropdown,
    showQuestCount: false,
    showQuestDropdown: !hideQuestDropdown
  }), tabList.length > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabList
  })) : tabList[0].content);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    assignmentId: state.assignment.admin.currentAssignmentId,
    deploymentIds: state.assignment.admin.currentDeploymentIds,
    projectAssignments: (0, _admin.getCurrentProjectAssignments)(state.assignment.admin),
    project: (0, _admin.getCurrentProject)(state.assignment.admin)
  };
};
Status.defaultProps = {
  showByWhitelist: ['assignment', 'module', 'survey']
};
Status.propTypes = {
  assignmentId: _propTypes["default"].number,
  assignmentIdWhitelist: _propTypes["default"].array,
  customSwitchProject: _propTypes["default"].func,
  deploymentIdWhitelist: _propTypes["default"].array,
  deploymentIds: _propTypes["default"].array,
  hideDeploymentDropdown: _propTypes["default"].bool,
  hideProjectDropdown: _propTypes["default"].bool,
  hideQuestDropdown: _propTypes["default"].bool,
  hideSystemId: _propTypes["default"].bool,
  isExported: _propTypes["default"].bool,
  labelForDeployment: _propTypes["default"].string,
  labelForLesson: _propTypes["default"].string,
  labelForProject: _propTypes["default"].string,
  labelForProjectPlural: _propTypes["default"].string,
  labelForQuest: _propTypes["default"].string,
  labelForShowByAssignment: _propTypes["default"].string,
  labelForShowByModule: _propTypes["default"].string,
  labelForShowBySurvey: _propTypes["default"].string,
  labelForSurvey: _propTypes["default"].string,
  pawnIdWhitelist: _propTypes["default"].arrayOf(_propTypes["default"].number),
  project: _propTypes["default"].object,
  projectAssignments: _propTypes["default"].array,
  projectIdWhitelist: _propTypes["default"].array,
  showByWhitelist: _propTypes["default"].arrayOf(_propTypes["default"].string),
  // 'survey', 'module', or 'assignment'
  surveyHandleWhitelist: _propTypes["default"].arrayOf(_propTypes["default"].string),
  renderCertificate: _propTypes["default"].func,
  setColumnDefinitions: _propTypes["default"].func,
  showOnlyFlags: _propTypes["default"].bool,
  overrideDeploymentIds: _propTypes["default"].array,
  adjustColumns: _propTypes["default"].func,
  customQuery: _propTypes["default"].object,
  customQueryVariables: _propTypes["default"].object,
  hideResolveAction: _propTypes["default"].bool,
  roleHandles: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(Status);